interface RegEx {
    GOOGLE_SEARCH: RegExp,
    INSTRUMENT_SEARCH: RegExp
}
export function filterQuery(text:string, regEx:RegExp):string {
	// Regex will allow only alphanumeric and  special chars: -&)(.% in between
	if (!regEx.test(text)) {
		return '';
	}

	return text.trim().toLowerCase();
}
export const regEx:RegEx = {
	/* eslint-disable */
	GOOGLE_SEARCH: /.*/,
	INSTRUMENT_SEARCH: /^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 \-\&\.\(\)\%]*)?$/
};
